/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNavigate } from "react-router-dom";
import { Box, Button, Group, Modal, SimpleGrid, Text } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { useUserProvider } from "@/utils/UserProvider";
import { ESSENTIAL_LIMITS, FREE_LIMITS } from "@/utils/checkSubscriptionUsage";
import { addCharacterS } from "@/utils/utils";

type payWallProps = {
  modalOpened: boolean;
  setModalOpened: (value: boolean) => void;
};

const PayWallModal = (props: payWallProps) => {
  const { modalOpened, setModalOpened } = props;
  const { revcatUser, amplifyUser } = useUserProvider();
  const navigate = useNavigate();

  const closeAndResetModal = () => {
    setModalOpened(false);
  };

  const getResetDate = () => {
    let resetDate = new Date();
    resetDate = new Date(resetDate.getFullYear(), resetDate.getMonth() + 1, 1);
    return resetDate;
  };

  return (
    <Modal
      opened={modalOpened}
      onClose={closeAndResetModal}
      title={`Plan: Manta Classic ${revcatUser.essential ? "Essential" : revcatUser.premium ? "Premium" : "Free"}`}
    >
      <Box style={{ marginBottom: 16 }}>
        <SimpleGrid cols={{ base: 1, sm: 3 }}>
          <Box ta={"center"}>
            <Text ta="center" fz="md" fw={600}>
              {amplifyUser === null ? 0 : amplifyUser.currentTemplatesUsed}
              {amplifyUser?.currentTemplatesUsed === null ? 0 : null}
            </Text>
            {amplifyUser !== null && (
              <Text c="dimmed" fz={"sm"}>
                Template{addCharacterS(amplifyUser.currentTemplatesUsed)} Used
              </Text>
            )}
          </Box>
          <Box ta={"center"}>
            <Text ta="center" fz="md" fw={600}>
              {amplifyUser === null
                ? 0
                : amplifyUser.currentTranscriptionsCreated}
              {amplifyUser?.currentTranscriptionsCreated === null ? 0 : null}
            </Text>
            {amplifyUser !== null && (
              <Text c="dimmed" fz={"sm"}>
                Transcription
                {addCharacterS(amplifyUser?.currentTranscriptionsCreated)}
              </Text>
            )}
          </Box>
          <Box ta={"center"}>
            <Text
              ta="center"
              c={
                revcatUser.essential
                  ? amplifyUser?.currentCasesCreated >= ESSENTIAL_LIMITS.cases
                    ? "red"
                    : ""
                  : amplifyUser?.currentCasesCreated >= FREE_LIMITS.cases
                    ? "red"
                    : ""
              }
              fz="md"
              fw={600}
            >
              {amplifyUser === null ? 0 : amplifyUser?.currentCasesCreated}
              {amplifyUser?.currentCasesCreated === null ? 0 : null}
            </Text>
            {amplifyUser !== null && (
              <Text c="dimmed" fz={"sm"}>
                Case{addCharacterS(amplifyUser?.currentCasesCreated)} Created
              </Text>
            )}
          </Box>
        </SimpleGrid>
        <Text ta={"center"} my={15} fz="md" fw={600}>
          Limits reset {getResetDate().toLocaleDateString()}
        </Text>
      </Box>
      <Group mt="md">
        <Button onClick={() => navigate("/plans?upgrade=true")} mx={"auto"}>
          Upgrade to Premium
        </Button>
      </Group>
      <Text size="md" c="#003554" fw={500} pt={10}>
        <IconCheck /> Unlimited access to templates
      </Text>
      <Text size="md" c="#003554" fw={500} pt={10}>
        <IconCheck /> Unlimited transcriptions
      </Text>
      <Text size="md" c="#003554" fw={500} pt={10}>
        <IconCheck /> Unlimited cases
      </Text>
    </Modal>
  );
};

export default PayWallModal;
